<template>
  <div class="pagination">
    <!-- 首页按钮 -->
    <button class="pagination-btn first-btn" @click="goToFirstPage">
      首页
    </button>
  
    <!-- 上一页按钮 -->
    <!-- <button class="pagination-btn page-btn" :class="{ disabled: isPageDisabled('prev') }" @click="goToPrevPage">
      &lt;
    </button> -->
  
    <!-- 页码按钮 -->
    <button v-for="page in displayedPages" :key="page" class="pagination-btn page-btn"
      :class="{ active: page === currentPage }" @click="page !== '...' && goToPage(page)">
      {{ page }}
    </button>
  
    <!-- 下一页按钮 -->
    <button class="pagination-btn page-btn" :class="{ disabled: isPageDisabled('next') }" @click="goToNextPage">
      &gt;
    </button>
  
    <!-- 末页按钮 -->
    <button class="pagination-btn first-btn" :class="{ disabled: isPageDisabled('last') }" @click="goToLastPage">
      末页
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalItems: {
      type: Number,
      required: true,
      default: 100
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    displayedPages() {
      const pages = [];
      const current = this.currentPage;
      const total = this.totalPages;

      pages.push(1);

      if (current > 2) {
        pages.push('...');
      }

      for (let i = current - 1; i <= current + 1; i++) {
        if (i > 1 && i < total && !pages.includes(i)) {
          pages.push(i);
        }
      }

      if (current < total - 1) {
        pages.push('...');
      }

      if (total > 1 && !pages.includes(total)) {
        pages.push(total);
      }

      return pages;
    }
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit('page-changed', page);
      }
    },
    goToFirstPage() {
      this.goToPage(1);
    },
    goToLastPage() {
      this.goToPage(this.totalPages);
    },
    goToNextPage() {
      this.goToPage(this.currentPage + 1);
    },
    goToPrevPage() {
      this.goToPage(this.currentPage - 1);
    },
    isPageDisabled(direction) {
      if (direction === 'first' || direction === 'prev') {
        return this.currentPage <= 1;
      } else if (direction === 'next' || direction === 'last') {
        return this.currentPage >= this.totalPages;
      }
      return false;
    }
  }
};
</script>

<style scoped>
/* 分页组件样式 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  gap: 8px;
}

.pagination-btn {
  /* min-width: 40px; */
  height: 40px;
  padding: 0 15px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  border: none;
  background: #f5f5f5;
  color: #555;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pagination-btn:hover:not(.disabled, .active) {


  color: #fff;
  background: #6e0104;
  border-color: #6e0104;

}

.pagination-btn.active {

  background: #cc0000;
  border-color: #cc0000;
  color: #fff;
}

.pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.first-btn {
  font-size: 14px;
  color: #777;
  font-weight: normal;
  display: inline-block;
  height: 27px;
  line-height: 25px;
  padding: 0 8px;
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  vertical-align: middle;
  background-color: white;
}

.page-btn {
  font-size: 14px;
  color: #777;
  font-weight: normal;
  display: inline-block;
  height: 27px;
  line-height: 25px;
  padding: 0 8px;
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  vertical-align: middle;
  background-color: white;
}
</style>